import { toArray } from "lodash";
import { useSnackbar } from "notistack";
import { useRef } from "react";
import {
  BusinessEntityType,
  useAddBillingRuleMutation,
  useDeleteBillingRuleMutation,
  useEditBillingRuleMutation,
  useGetBrokerDetailsQuery,
  useGetCustomerDetailsQuery,
} from "../../../graphql/generated";
import ErrorMessage from "../../common/ErrorMessage/ErrorMessage";
import LoadingOverlay from "../../common/LoadingOverlay";
import BillingRulesEditor from "./BillingRulesEditor";

type BillignRulesEditorContainerProps = {
  customerId: string;
  customerType: BusinessEntityType.Customer | BusinessEntityType.Broker;
};

const BillingRulesEditorContainer = ({
  customerId,
  customerType,
}: BillignRulesEditorContainerProps) => {
  const initialCustomerType = useRef(customerType);

  const getCustomerQuery =
    initialCustomerType.current === BusinessEntityType.Customer
      ? // eslint-disable-next-line react-hooks/rules-of-hooks
        useGetCustomerDetailsQuery({
          id: customerId,
        })
      : // eslint-disable-next-line react-hooks/rules-of-hooks
        useGetBrokerDetailsQuery({
          id: customerId,
        });
  const editBillingRuleMutation = useEditBillingRuleMutation();
  const addBillingRuleMutation = useAddBillingRuleMutation();
  const deleteBillingRuleMutation = useDeleteBillingRuleMutation();
  const { enqueueSnackbar } = useSnackbar();

  if (getCustomerQuery.isLoading) {
    return <LoadingOverlay loading />;
  }

  if (
    getCustomerQuery.error ||
    !getCustomerQuery.data ||
    !toArray(getCustomerQuery.data)[0]
  ) {
    return (
      <ErrorMessage
        error={
          getCustomerQuery.error || "Unknown error while fetching customer"
        }
      />
    );
  }
  return (
    <>
      <ErrorMessage
        error={
          editBillingRuleMutation.error ||
          addBillingRuleMutation.error ||
          deleteBillingRuleMutation.error
        }
      />
      <BillingRulesEditor
        customer={toArray(getCustomerQuery.data)[0]}
        customerId={customerId}
        addBillingRuleMutation={addBillingRuleMutation}
        editBillingRuleMutation={editBillingRuleMutation}
        deleteBillingRuleMutation={deleteBillingRuleMutation}
        enqueueSnackbar={enqueueSnackbar}
      />
    </>
  );
};

export default BillingRulesEditorContainer;
